import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetUserChatsDataTypes } from "../../../../Schema/getUserChats.types";
import { SegmentAnswersTypes } from "../../segmentAnswers/segmentAnswers";

export type PostUserServiceEntryLoadAction = {
  type: string;
  payload: {
    userServiceId: number;
    dataEntry: SegmentAnswersTypes[];
    path?: string;
    router?: any;
  };
};

export type PostUserServiceEntryData = {
  data: { data: GetUserChatsDataTypes[] };
};

export const PostUserServiceEntry = new ReduxFetchState<
  PostUserServiceEntryData | null,
  {
    userServiceId: number;
    dataEntry: SegmentAnswersTypes[];
    path?: string;
    router?: any;
  },
  any
>("postUserServiceEntry");

export function* watchPostUserServiceEntry(
  action: PostUserServiceEntryLoadAction,
) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    const { userServiceId, dataEntry, router, path } = action.payload;

    const data: PostUserServiceEntryData = yield axios({
      url: `/api/v1/ai/user-service/${userServiceId}/entry`,
      method: "POST",
      data: { data: dataEntry },
      headers: { lang },
    });

    yield put(PostUserServiceEntry.actions.loadSuccess({ data: data.data }));
    if (router && path) {
      router(path);
    }
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(PostUserServiceEntry.actions.loadFailure(e.message));
  }
}

export function* postUserServiceEntrySagas() {
  yield takeEvery(
    PostUserServiceEntry.actionTypes.load,
    watchPostUserServiceEntry,
  );
}

export function usePostUserServiceEntry() {
  const { loading, data, ...postUserServiceEntryState } = useAppSelector(
    (state) => state.postUserServiceEntry,
  );
  const dispatch = useAppDispatch();

  const dispatchPostUserServiceEntry = useCallback(
    (data: {
      userServiceId: number;
      dataEntry: SegmentAnswersTypes[];
      path?: string;
      router?: any;
    }) => {
      dispatch(PostUserServiceEntry.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...postUserServiceEntryState,
    dispatchPostUserServiceEntry,
    postUserServiceEntryLoading: loading,
    postUserServiceEntryData: data,
  };
}

export const {
  actionTypes: postUserServiceEntryActionsTypes,
  actions: postUserServiceEntryActions,
  reducer: postUserServiceEntryReducer,
} = PostUserServiceEntry;
